import { jsx } from "@emotion/react/jsx-runtime";
import { Tabs as Tabs$1 } from "@mui/material";
import { ChevronLeft, ChevronRight } from "react-feather";
import { tabsStyles, iconStyles } from "./Tabs.styles.js";
const StartScrollButtonIcon = () => {
  return /* @__PURE__ */ jsx(ChevronLeft, { css: iconStyles });
};
const EndScrollButtonIcon = () => {
  return /* @__PURE__ */ jsx(ChevronRight, { css: iconStyles });
};
const Tabs = (props) => {
  return /* @__PURE__ */ jsx(Tabs$1, { css: tabsStyles, slots: {
    StartScrollButtonIcon,
    EndScrollButtonIcon
  }, ...props });
};
export {
  Tabs
};
//# sourceMappingURL=Tabs.js.map
